import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { FormInput, updateFormDataField } from 'cng-common/features/form'

import { MAX_NAME_LENGTH } from './configs'

interface IProps {
  initialValue: string
  formKey: string
  isDisabled?: boolean
  label?: string
  placeholder?: string
}

export const Name = ({ initialValue, formKey, isDisabled, label, placeholder }: IProps) => {
  const dispatch = useAppDispatch()

  const handleChange = useCallback(
    (value: string) => {
      if (value.length >= MAX_NAME_LENGTH) {
        dispatch(
          updateFormDataField({
            field: 'name',
            value: value.slice(0, MAX_NAME_LENGTH),
            formKey: formKey,
          })
        )
      }
    },
    [dispatch, formKey]
  )

  return (
    <FormInput
      isDisabled={isDisabled}
      isRequired
      formKey={formKey}
      field="name"
      defaultValue={initialValue}
      type="text"
      label={label}
      placeholder={placeholder}
      onChange={handleChange}
    />
  )
}
